import { useTranslation } from 'react-i18next';
import './contract-details.component.scss';

interface ContractDetailsProps {
    certificateId?: number;
    empName: string;
    socialSecurityNumber: string;
}

export const ContractDetails: React.FC<ContractDetailsProps> = ({
    certificateId,
    empName,
    socialSecurityNumber
}) => {
    const { t } = useTranslation();

    return (
        <div className="contract-details">
            <div className="contract-details__row">
                {certificateId && (
                    <div className="contract-details__field">
                        <span className="contract-details__label">{t('Contract No.')} : </span>
                        <span className="contract-details__value">{certificateId}</span>
                    </div>
                )}
                
                <div className="contract-details__field">
                    <span className="contract-details__label">{t('Emp. name')} : </span>
                    <span className="contract-details__value">{empName}</span>
                </div>
                
                <div className="contract-details__field">
                    <span className="contract-details__label">{t('Social Security Number')} ({t('12 digits')}) : </span>
                    <span className="contract-details__value">{socialSecurityNumber}</span>
                </div>
            </div>
        </div>
    );
};
